var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListIconOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create-Asset-Flows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design-Studio-Custom-Copy-9",
    transform: "translate(-351.000000, -640.000000)",
    fill: "#F98522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Slide-in-panel",
    transform: "translate(104.100301, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(58.902144, 592.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-6",
    transform: "translate(0.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Keyword-Copy-6",
    transform: "translate(179.997555, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-Icon-Grey",
    transform: "translate(8.974359, 9.700000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1.333333, 5.957692) rotate(-90.000000) translate(-1.333333, -5.957692) translate(-4.624359, 4.624359)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 1.30769231,
    cy: 1.33333333,
    rx: 1.30769231,
    ry: 1.33333333
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    cx: 6.00769231,
    cy: 1.33333333,
    rx: 1.30769231,
    ry: 1.33333333
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    cx: 10.6076923,
    cy: 1.33333333,
    rx: 1.30769231,
    ry: 1.33333333
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.94871795,
    y: 0.3,
    width: 9,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 3.94871795,
    y: 4.96666667,
    width: 9,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 3.94871795,
    y: 9.63333333,
    width: 9,
    height: 2,
    rx: 1
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconOrange);
export default __webpack_public_path__ + "static/media/ListIconOrange.2b5d6243.svg";
export { ForwardRef as ReactComponent };